<template>
  <v-dialog v-model="showModal" max-width="800">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ $tc('title.erro', 2) }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="cabecalho"
          :items="erros"
          hide-default-footer>
          <template v-slot:item.erro="{ item }">
            {{ item.texto }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" text @click.native="confirma">{{ $t('label.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
      erros: [],
      cabecalho: [
        {
          text: this.$tc('label.celula', 1), value: 'celula', sortable: false, width: '20%',
        },
        { text: this.$tc('label.erro', 1), value: 'erro', sortable: false },
      ],
      mapaCampos: {},
      erro: '',
    };
  },
  props: {
    getCelulaEntidade: {
      type: Function,
      required: true,
    },
    metadadosOrcamento: {
      type: Object,
      required: true,
    },
    metadadosLinha: {
      type: Object,
      required: true,
    },
  },
  methods: {
    confirma() {
      this.showModal = false;
    },
    apresentaErrosServidor(res) {
      const objErros = JSON.parse(res.bodyText);

      if (objErros.erros_planilha) {
        this.showModal = true;
        this.apresentaErrosPlanilha(objErros);
      } else {
        this.apresentaOutrosErros(res);
      }
    },
    apresentaOutrosErros(res) {
      this.$toast(res.data.error);
    },
    apresentaErrosPlanilha(objErros) {
      this.erros = [];
      const { linhas } = objErros;
      const indices = Object.keys(linhas);
      indices.forEach((indice) => {
        const erros = linhas[indice];
        this.montaErros(erros, indice);
      });
    },
    montaErros(erros, indice) {
      erros.forEach((item) => {
        const { entidade, tipo } = item;
        const celula = this.montaCelulaErro(entidade, indice);

        const erro = { ...item };

        erro.entidade = this.mapaCampos[item.entidade]
          || `${erro.entidade}`;
        erro.entidade_ref = this.mapaCampos[item.entidade_ref]
          || item.entidade_ref;

        if (tipo === 'relacionamento') {
          const texto = this.montaErroRelacionamento(erro);
          this.erros.push({ celula, texto });
        } else if (tipo === 'extensao' || tipo === 'padrao' || tipo === 'inconsistente') {
          const texto = this.montaErroEntidadeInvalida(erro);
          this.erros.push({ celula, texto });
        } else if (tipo === 'obrigatorio') {
          const texto = this.montaErroObrigatorio(erro);
          this.erros.push({ celula, texto });
        } else if (tipo === 'distribuido') {
          const texto = this.montaErroDistribuido(erro);
          this.erros.push({ celula, texto });
        } else if (tipo === 'linha_duplicada') {
          const texto = this.montaErroLinhaDuplicada(erro);
          this.erros.push({ celula, texto });
        }
      });
    },
    montaErroRelacionamento(erro) {
      return this.$t('errors.planilha.relacionamento', erro);
    },
    montaErroEntidadeInvalida(erro) {
      return this.$t('errors.planilha.entidade_invalida', erro);
    },
    montaErroObrigatorio(erro) {
      return this.$t('errors.planilha.obrigatorio', erro);
    },
    montaErroDistribuido(erro) {
      return this.$t('errors.planilha.distribuido', erro);
    },
    montaErroLinhaDuplicada(erro) {
      return this.$t('errors.planilha.informacao_duplicada', erro);
    },
    montaCelulaErro(entidade, indice) {
      return `${this.getCelulaEntidade(entidade)}${indice}`;
    },
    montaMapaCamposMetadados(metadados) {
      const { mapaEntidades, mapaCamposDinamicos } = metadados;

      this.mapaCampos.produto = this.$tc('label.produto', 1);
      this.mapaCampos.cliente = this.$tc('label.cliente', 1);
      this.mapaCampos.centro_custo = this.$tc('label.centro_custo', 1);
      this.mapaCampos.divisao = this.$tc('label.divisao', 1);
      this.mapaCampos.descricao_linha = this.$tc('label.linha_investimento', 1);
      this.mapaCampos.tipo_investimento = this.$tc('label.relatorios.tipo_investimento', 1);

      Object.keys(mapaEntidades).forEach((key) => {
        const obj = mapaEntidades[key];
        this.mapaCampos[key] = obj.entidadeEstrangeira;
      });
      Object.keys(mapaCamposDinamicos).forEach((key) => {
        const obj = mapaCamposDinamicos[key];
        this.mapaCampos[key] = obj.nomCampo;
      });
    },
    montaMapaCampos() {
      this.montaMapaCamposMetadados(this.metadadosOrcamento);
      this.montaMapaCamposMetadados(this.metadadosLinha);
    },
  },
  mounted() {
    this.montaMapaCampos();
  },
};
</script>
